import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, interval, Subscription } from 'rxjs';
import { ProcessTaskCenterService } from './ProcessTaskCenterService';
import { AdminTaskService } from './AdminTaskService';

@Injectable({ providedIn: 'root' })
export class TaskCenterNotificationService {
  private pendingCountSubject = new BehaviorSubject<number>(0);
  pendingCount$ = this.pendingCountSubject.asObservable();
  private actionRequiredCountSubject = new BehaviorSubject<number>(0);
  actionRequiredCount$ = this.actionRequiredCountSubject.asObservable();
  private collectionCaseCountSubject = new BehaviorSubject<number>(0);
  collectionCaseCount$ = this.collectionCaseCountSubject.asObservable();
  private polling: Subscription;
  private request: Subscription;

  constructor(
    private processTaskCenterService: ProcessTaskCenterService,
    private adminTaskService: AdminTaskService
  ) { }

  refreshPendingCount(): void {
    if (!this.polling || this.polling.closed) {
      this.polling = interval(60000).subscribe(() => this.loadCounts());
    }
    this.loadCounts();
  }

  private loadCounts(): void {
    this.request?.unsubscribe();
    this.request = combineLatest({
      summary: this.processTaskCenterService.getSummary(),
      certificates: this.adminTaskService.getEmployerCertificatePendingCount()
    }).subscribe(
      ({ summary, certificates }) => {
        const actions = this.normalizeCount(summary.ActionRequiredCount);
        const cases = this.normalizeCount(summary.CollectionCaseCount);
        this.actionRequiredCountSubject.next(actions);
        this.collectionCaseCountSubject.next(cases);
        if (certificates >= 0) {
          this.pendingCountSubject.next(actions + cases + this.normalizeCount(certificates));
        }
      },
      error => {
        // Keep the last known count on a temporary error; clear it when access ends.
        if (error.status === 401 || error.status === 403) this.reset();
      }
    );
  }

  reset(): void {
    this.polling?.unsubscribe();
    this.request?.unsubscribe();
    this.pendingCountSubject.next(0);
    this.actionRequiredCountSubject.next(0);
    this.collectionCaseCountSubject.next(0);
  }

  private normalizeCount(value: number): number {
    if (typeof value !== 'number' || !isFinite(value) || value < 0) {
      return 0;
    }

    return Math.floor(value);
  }

}
